import { ReleasesPopUp } from './ReleasesPopUp';
import { ReleasesModal } from './ReleasesModal';
import { releaseItems } from './releaseItems';
import { useState, useMemo } from 'react';
import { Session } from '@ory/client-fetch';
import { AnimatePresence } from 'framer-motion';
import { useUserMetaData } from '~/hooks/useUserMetaData';
import { type UserMetadata } from '~/services/organisations-api/types';
import { usePrevious } from '~/hooks/usePrevious';

export function Releases({ currentSession }: { currentSession: Session | null }) {
  const { userMetaData, updateUserMetaData } = useUserMetaData();
  const [dismissedReleases, setDismissedReleases] = useState<boolean>(false);
  const usersReleasesPosition = useMemo(() => {
    if (!currentSession?.identity?.metadata_public) {
      return 0;
    }
    return (
      (userMetaData.releaseAcknowledged ||
        (currentSession.identity?.metadata_public as UserMetadata).releaseAcknowledged) ??
      0
    );
  }, [currentSession, userMetaData]);

  const usersPreviousReleasesPosition = usePrevious(
    (currentSession?.identity?.metadata_public as UserMetadata)?.releaseAcknowledged || 0
  );
  const userBehindByMultiple = useMemo(() => {
    return releaseItems.length - usersPreviousReleasesPosition > 1;
  }, [usersReleasesPosition]);

  const [openModal, setOpenModal] = useState(false);

  const handleUserDecision = (open: boolean) => {
    updateUserMetaData({
      body: {
        releaseAcknowledged: releaseItems.length,
      },
    });
    setDismissedReleases(true);
    setOpenModal(open);
  };

  return (
    <>
      <AnimatePresence>
        {releaseItems.length > usersReleasesPosition && !dismissedReleases && (
          <ReleasesPopUp handleUserDecision={handleUserDecision} userBehindByMultiple={userBehindByMultiple} />
        )}
      </AnimatePresence>
      <ReleasesModal
        open={openModal}
        setOpen={setOpenModal}
        usersPreviousReleasesPosition={usersPreviousReleasesPosition}
      />
    </>
  );
}
